import Coupon from 'Components/Coupons/components/Coupon/Coupon';

export default Coupon;
